import React from "react";

interface IconProps {
    className?: string;
  }

const BackgroundsIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    id="Layer_1"
    height="512"
    viewBox="0 0 36 36"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    className={className}
  >
    <path d="m30.31 2h-24.62a3.68 3.68 0 0 0 -3.69 3.69v24.61a3.59 3.59 0 0 0 .4 1.7l16.77-13.66a6 6 0 0 1 7.54-.08l7.29 5.67v-18.24a3.69 3.69 0 0 0 -3.69-3.69zm-19.7 14.77a3.69 3.69 0 1 1 3.7-3.69 3.7 3.7 0 0 1 -3.7 3.69z" /><path d="m25.3 20.07 8.7 6.75v3.48a3.7 3.7 0 0 1 -3.69 3.7h-24.62a3.75 3.75 0 0 1 -1.69-.4l16.61-13.49a3.76 3.76 0 0 1 4.69-.04z" />
  </svg>
);

export default BackgroundsIcon;
